<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  ВДСК - оптовая торговля нефтепродуктами и инертными
                  материалами в Кирове Мы рады приветствовать Вас на сайте ООО
                  «Вятская Дорожно-Строительная Компания»! ООО «ВДСК» на
                  сегодняшний день динамично развивающаяся компания в сфере
                  оптовой торговли нефтепродуктами и инертными материалами.
                </p>
                <p>
                  Нами проводится огромная работа по организации поставок таких
                  незаменимых для дорожного строительства материалов, как
                  дорожный битум, щебень, гравий и песок.
                </p>
                <p>
                  Нашей компанией были разработаны и применены оптимальные
                  логистические схемы для доставки их на территорию Кировской
                  области, а впоследствии и в прилегающие регионы. Компания
                  закупает битумные материалы по прямым договорам с ООО
                  «ГАЗПРОМНЕФТЬ-БМ", ООО «ЛЛК-Интернешнл» (ЛУКОЙЛ), ТАИФ-НК
                  (ОАО), Камбит НК (ООО), ТД БИЭМ, ООО (г.Пермь),
                  Ярославнефтеоргсинтез, заводами Уфимской группы.
                </p>
                <p>
                  Сотрудничество со столь именитыми компаниями говорит само за
                  себя - мы предоставляем только качественную, первосортную
                  продукцию от проверенных и надежных производителей. Кроме
                  того, прямые контакты с ведущими производителями
                  нефтепродуктов позволяют нам устанавливать максимально низкие
                  цены на товары, а для крупных оптовых покупателей
                  реализовывать гибкую и выгодную ценовую политику.
                </p>

                <p>
                  С 2018 года наша Компания является официальным дистрибьютором
                  ООО «ЛЛК-Интернешнл» (дочернее общество ПАО «ЛУКОЙЛ»). ООО
                  «ВДСК» реализует дорожный битум на территории Кировской
                  области, Республики Татарстан, Удмуртской Республики,
                  Чувашской Республики и Республики Коми.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+78332265251"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (8332) 26-52-51</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:vdsk.kirov@bk.ru"
                          class="ViewPromo__advantage-contact-link"
                          >vdsk.kirov@bk.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «ВДСК»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1304,
    productId: 1643,
    name: 'ООО «ВДСК»',
    inn: '4345396985 ',
  }),
};
</script>
